import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/copy.svg'


const _hoisted_1 = { class: "inline-flex items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "copy",
  class: "inline ml-2 cursor-pointer"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_tooltip = _resolveComponent("n-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: "inline cursor-pointer",
    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleCopy && _ctx.handleCopy(...args)), ["stop"])),
    onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
  }, [
    _createVNode(_component_n_tooltip, {
      trigger: "hover",
      placement: "right",
      style: { padding: '0 5px 3px 5px' }
    }, {
      trigger: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, [
          _createElementVNode("div", null, _toDisplayString(_ctx.truncatedAddress), 1),
          _hoisted_2
        ])
      ]),
      default: _withCtx(() => [
        _createTextVNode(" " + _toDisplayString(_ctx.copyText), 1)
      ]),
      _: 1
    })
  ], 32))
}